export default __webpack_public_path__ + "static/media/Bichitrananada Biswal, Member, NIBA Alumni Association.dbe48546.jpg";